import htmx from "htmx.org";

htmx.defineExtension("json-trigger", {
  transformResponse(text, xhr) {
    const contentType = xhr.getResponseHeader("Content-Type") || "";
    if (contentType.indexOf("application/json") > -1) {
      try {
        const eventName = xhr.getResponseHeader("HX-Json-Trigger");
        if (eventName === null) {
          console.error("Could not find eventName from HX-Json-Trigger");
          return "";
        }

        const jsonResponse = JSON.parse(text);
        document.dispatchEvent(
          new CustomEvent(eventName, {
            detail: jsonResponse,
            bubbles: true,
            cancelable: true,
          })
        );
      } catch (error) {
        console.error("JSON parsing error:", error);
        return "";
      }
    }
    return text;
  },
});
